var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGheeIndigenousMethod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 760",
    role: "img",
    style: {},
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Indigenous method for Badri cow ghee") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Vertical flowchart: raw Badri cow milk through boiling, culture inoculation, fermentation, bilona churning, makkhan, ghee boiling and filtration to final desi ghee, with desi buttermilk and ghee residue as byproducts."), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "context-stroke",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('Why is raw Badri cow milk the basis of this method?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 40,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 62,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Raw Badri cow milk"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 80,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Indigenous Himalayan breed")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 96,
    x2: 290,
    y2: 114,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What happens during boiling in ghee prep?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 118,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 140,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Boiling"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 158,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Heat treatment, then cool")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 174,
    x2: 290,
    y2: 192,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What culture is used for inoculation?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 196,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 218,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Culture inoculation"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 236,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Add curd starter")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 252,
    x2: 290,
    y2: 270,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('Why ferment to ~1% lactic acid?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 274,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 296,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Fermentation"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 314,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Curd set, ~1% lactic acid")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 330,
    x2: 290,
    y2: 348,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What is bilona churning?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 352,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 374,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Churning (bilona)"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 392,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Traditional hand churn")), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 380,
    x2: 448,
    y2: 380,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What is desi buttermilk used for?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 352,
    width: 180,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(68, 68, 65)",
      stroke: "rgb(180, 178, 169)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 374,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(211, 209, 199)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Desi buttermilk"), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 392,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(180, 178, 169)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Chaas, byproduct")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 408,
    x2: 290,
    y2: 426,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What is makkhan?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 430,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 452,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Makkhan"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 470,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Cultured butter")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 486,
    x2: 290,
    y2: 504,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What happens during ghee boiling?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 508,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 530,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Ghee boiling"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 548,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Clarify by heat, remove water")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 564,
    x2: 290,
    y2: 582,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What is ghee filtration and ghee residue?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 586,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(12, 68, 124)",
      stroke: "rgb(133, 183, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 608,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Ghee filtration"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 626,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(133, 183, 235)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Separate solids")), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 614,
    x2: 448,
    y2: 614,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What is ghee residue and how is it used?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 586,
    width: 180,
    height: 56,
    rx: 8,
    strokeWidth: 0.5,
    style: {
      fill: "rgb(68, 68, 65)",
      stroke: "rgb(180, 178, 169)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 608,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(211, 209, 199)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Ghee residue (GR)"), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 626,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(180, 178, 169)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "65\u201380% fat, byproduct")), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 642,
    x2: 290,
    y2: 660,
    markerEnd: "url(#arrow)",
    style: {
      fill: "none",
      stroke: "rgb(156, 154, 146)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    onclick: "sendPrompt('What makes Badri cow desi ghee distinctive?')",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 664,
    width: 220,
    height: 56,
    rx: 8,
    strokeWidth: 1,
    style: {
      fill: "rgb(99, 56, 6)",
      stroke: "rgb(239, 159, 39)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 686,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(250, 199, 117)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Badri cow desi ghee"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 704,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fill: "rgb(239, 159, 39)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  }, "Final product")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGheeIndigenousMethod);
export default __webpack_public_path__ + "static/media/ghee_indigenous_method.b65c3dc2174f22e493871fe213616c47.svg";
export { ForwardRef as ReactComponent };